import React from "react";
import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import LogoStrip from "./components/LogoStrip";
import Services from "./components/Services";
import Approach from "./components/Approach";
import About from "./components/About";
import Clients from "./components/Clients";
import CtaBand from "./components/CtaBand";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import useReveal from "./hooks/useReveal";

function App() {
  useReveal();
  return (
    <>
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <LogoStrip />
        <Services />
        <Approach />
        <About />
        <Clients />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
